import React, { useEffect, useMemo, useState } from 'react';
import {
    Grid,
    IconButton,
    InputAdornment,
    TextField } from '../../ui';
import { useSelector } from 'react-redux';
import RenderBillHeader from '../mart/RenderBillHeader';
import RenderItemSearch from './RenderItemSearch';
import RestoBillPayScreen from './RestoBillPayScreen';
import uiUtilInstance from '../../../utilities/uiUtil';
import { INITIAL_BILL_UTILS,
    INITIAL_CUSTOMER_DATA,
    INITIAL_EXTERNAL_MAP,
    INITIAL_ITEM_DIALOG,
    INITIAL_PARTIAL_PAY,
    INITIAL_PAYMENT_MODEL,
    INITIAL_POINT_DETAILS,
    INITIAL_REFERENCE_BILL_DETAILS,
    INITIAL_TRIP_DETAILS } from '../resto-billing/RestBillConstants';
import utilities from '../../../utilities/utilities';
import {
  ASKFORPRINT,
  BACKDATEALLOWED,
  BillStatus,
  CART_INITIAL_STATE,
  CASHPAY,
  CUSTLOYALITYPOINT,
  CUSTOMER_DISABLE_IN_BILL,
  DEL_ITEM_BILL,
  DELETEBILL,
  DELETEBILLCONFIG,
  DELETEREASON,
  DELROOM,
  EPAYMENTSMS,
  FETCHFEWEMPLOYEE,
  GENERATEBILL,
  GETKOTBYITEM,
  getPreUrlAccordingToCart,
  GSTFEATURE,
  HOMEDELVDETAILS,
  HOTELSALESCONFIG,
  INITIATEPAYLINK,
  INITIATESAVEBILL,
  InternalBillType,
  isEmpty,
  isNumberEmpty,
  isRoleAllowed,
  ITEMWISEOFFER,
  KOTPRINTITEMWISE,
  KOTPRINTNOWISE,
  NOITEMSAVAILABLE,
  OfferType,
  PARTILBILLAUDIT,
  PAYLATERRESTOBILL,
  PayMedium,
  POSTRESTOBILL,
  PRINT_RESTO_BILL,
  PRINT_RESTO_BILL_MOBILE,
  PRINT_RESTO_KOT_ITEM,
  PRINT_RESTO_KOT_NO,
  printDebugLog,
  RESTO_KOT,
  ROLEERROR,
  SEND_TO_KITCHEN,
  SETTLE_RESTO_BILL,
  SUCCESS,
  UPDATEPARTIALPAY,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS
} from '../../../constants/constant';
import CustomDataGrid from '../../global/CustomDataGrid';
import AddIcon from '../../ui/icons/Add';
import RemoveIcon from '../../ui/icons/Remove';
import SnpButton from '../../global/SnpButton';
import { buildItems, kotJsonData, doTotal, getFinalPrice, handleDecrement, handleIncrement, payLaterJsonData, initiatePayJsonData, generateInititalPayLinkBillJsonData, buildJsonExternalData, buildJconCustData, updateBillStatus } from './quickBillController';
import { useLocation, useNavigate } from 'react-router-dom';
import { snpAxios } from '../../global/api';
import CommentIcon from '../../ui/icons/Comment';
import RestoButton from './RestoButton';
import { baseRaiseInvoiceClicked } from '../printBillApi';
import axios from 'axios';
import BuildDelItemDisplayData from './BuildDelItemDisplayData';
import RenderCustomerHotelForm from './RenderCustomerHotelForm';
import RestoDialogBase from './RestoDialogBase';
import SoupKitchenIcon from '../../ui/icons/SoupKitchen';
import BuildKotDisplayData from './BuildKotDisplayData';

const RestoKeyboardQuickBill = ({ showSnackbar, snpLoader, setSnpLoader, showDialog, closeDialog, dialogConfig }) => {

    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const colQuantityClasses = uiUtilInstance.useStyles();
    const location = useLocation();
    const navigate = useNavigate();

    const [columnList, setColumnList] = useState([]);
    const [delItems, setDelItems] = useState([]);
    const [customerData, setCustomerData] = useState(INITIAL_CUSTOMER_DATA);
    const [isPaid, setIsPaid] = useState(false);
    const [billNo, setBillNo] = useState("");
    const [billAddBy, setBillAddBy] = useState("");
    const [tableOwner, setTableOwner] = useState("");
    const [custAvailable, setCustAvailable] = useState(false);
    const [settleDown, setSettleDown] = useState(false);
    const [kot, setKot] = useState(0);
    const [billedFrom, setBilledFrom] = useState(-1);
    const [generateOtp, setGenateOtp] = useState("");
    const [billStatus, setBillStatus] = useState(BillStatus.NO_ENTRY);
    const [tokenNo, setTokenNo] = useState(-1);
    const [createdDate, setCreatedDate] = useState(uiUtilInstance.todayFormattedDate);
    const [paymentDetails, setPaymentDetails] = useState(INITIAL_PAYMENT_MODEL);
    const [billUtils, setBillUtils] = useState(INITIAL_BILL_UTILS);
    const [externalBillDetails, setExternalBillDetails] = useState(INITIAL_EXTERNAL_MAP);
    const [tripDetails, setTripDetails] = useState(INITIAL_TRIP_DETAILS);
    const [referenceBill, setReferenceBill] = useState(INITIAL_REFERENCE_BILL_DETAILS);

    const [delvNameOth, setDelvNameOth] = useState("");
    const [isOthHomeDelv, setOtherHomeDelv] = useState(false);
    const [printDetails, setPrintDetails] = useState({
        shopPrint: "",
        custPrint: "",
    });

    const [columnLoader, setColumnLoader] = useState(false); //Making slow Ui
    const [payLoader, setPaymentLoader] = useState(false);

    //Configs
    const [itemWiseOffer, setItemWiseOffer] = useState(false);
    const [backDateAllowed, setBackDateAllowed] = useState(false);
    const [deletBillOption, setDeleteBillOption] = useState(false);
    const [loyaltyPoints, setLoyalityPoints] = useState(false);
    const [partilBillAvail, setPartialBillAvail] = useState(false);
    const [delReason, setDelReason] = useState(false);
    const [hotelSale, setHotelSales] = useState(false);
    const [genBill, setGenBill] = useState(false);
    const [hotelDelvTxn, setHotelDelvTxn] = useState(false);
    const [kotPrintNoWise, setkotPrintNoWise] = useState(false);
    const [kotPrintItemWise, setKotPrintItemWise] = useState(false);
    const [askForPrint, setAskForPrint] = useState(false);
    const [ePayInvoice, setEPayInvoice] = useState(false);
    const [custDisableInBill, setCustDisableInBill] = useState(false);

    const [loyalityPointDetails, setLoyalityPointDetails] = useState(INITIAL_POINT_DETAILS);
    const [riders, setRiders] = useState([]);
    const [kotCopies, setKopies] = useState(1);

    const [itemDialog, setItemDialog] = useState(INITIAL_ITEM_DIALOG);
    //Partial Pay Related
    const [partialPayList, setPartialPayList] = useState([]);
    const [duesAmt, setDuesAmt] = useState(0.0);
    const [currDues, setCurrDues] = useState(0.0);
    const [takenPartialPay, setTakenPartialPay] = useState(false);
    const [partialPay, setPartialPay] = useState(INITIAL_PARTIAL_PAY);

    //Dialog Box used
    const [partialPayDialog, setPartialPayDialog] = useState(false);
    const [custCopy, setCustCopy] = useState(false);
    const [custDialog, setCustDialog] = useState(false);
    const [dateChange, setDateChange] = useState(false);
    const [hotelRoomDialog, setHotelRoomDialog] = useState(false);

    //Coupon Used
    const [coupon, setCoupon] = useState("");
    const [appliedCoupon, setAppliedCoupon] = useState(false);

    useEffect(() => {
        printDebugLog("useLayoutEffect ", location.state);
        getMultipleConfigs();
        if (location.state?.tableProps !== null) {
            const tableProps = location.state?.tableProps;
            const billType = location.state?.billType;
            setBillUtils(prev => ({
                ...prev,
                tableId: tableProps === undefined ? "" : tableProps.id,
                tableNo: tableProps === undefined ? -1 : tableProps.tableNo,
                billNo: tableProps === undefined ? "" : tableProps.billNo,
                tableName: tableProps === undefined ? "" : tableProps.tableName,
                billType: (billType !== -1) ? billType : InternalBillType.TakeAway,
            }));
        }

        if (!isEmpty(location.state?.sBillNo)) {
            fetchBill(location.state?.sBillNo);
        }


    }, [storeActiveShopHash, storeApiUrl, location.state]);

    useEffect(() => {
        printDebugLog("useEffect=> ", paymentDetails);
        //setPaymentDetails(paymentDetails);
    }, [paymentDetails])

    const handleClearUi = () => {
        setBillNo("");
        setCreatedDate(uiUtilInstance.todayFormattedDate);
        setColumnList([]);
        setPaymentDetails(INITIAL_PAYMENT_MODEL);
        setIsPaid(false);
        setCustomerData(INITIAL_CUSTOMER_DATA);
        setTokenNo(-1);
    };

    const showSnpDialogForShowStatus = (msg) => {
        showDialog({
            ...dialogConfig,
            negativeReq: true,
            negativeAction: "Ok!", subTitle: msg,
            handleClose: closeDialog,
        });
    };

    const handleGenBill = () => {
        if (genBill) {
            if (isEmpty(generateOtp)) {
                generateBill();
            } else {
                setItemDialog(prev => ({
                    ...prev, action: 2,
                }))
            }
        } else {
            generateBill();
        }
    };

    const setPrintKotNoDialog = () => {
        setItemDialog(prev => ({
            ...prev,
            action: 3,
        }))
    }

    const printCustomerBill = () => {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        baseRaiseInvoiceClicked(storeApiUrl.BACKEND_BASE_URL,
            CART_INITIAL_STATE.apiToken, storeActiveShopHash.id,
            printDetails.custPrint,
            "cust", isMobile, billNo, (msg) => fireSnackBarMsg({ msg: msg }));
        setCustCopy(false);
    };

    const callItemOperation = () => {
        if (itemDialog.action === 0) {
            setColumnList((prev) => {
                const index = prev.findIndex((item) => item.prdId === itemDialog.itemId);
                if (index !== -1) {
                    const updatedList = [...prev]; // clone array
                    updatedList[index] = {
                        ...updatedList[index],
                        note: itemDialog.dialogMsg,
                    };
                    return updatedList;
                }
                return prev;
            });
            setItemDialog(INITIAL_ITEM_DIALOG);
        } else if (itemDialog.action === 1) {
            deleteItemFromBill(itemDialog.itemId, itemDialog.itemName, itemDialog.dialogMsg);
        } else if (itemDialog.action === 2) {
            generateBill();
        } else {
            printKotNoWise();
        }
    }

    const handleUpdateColumn = (selectedItem, quantity) => {
        printDebugLog("handleUpdateColumn", selectedItem, quantity);
        baseUpdateItems(selectedItem, quantity, Number(selectedItem.price.sAmt), Number(selectedItem.offertype), selectedItem.id);
    };

    const updateBasedOnCoupon = (added, offerType, offerAmt, requiredPayMethodClear) => {
        printDebugLog("updateBasedOnCoupon", added, offerType, offerAmt, requiredPayMethodClear);
        doTotal(0.0, 0.0, Number(paymentDetails.cgst), Number(paymentDetails.sgst),
            loyalityPointDetails,
            paymentDetails.isGstAllowed,
            Number(paymentDetails.delvCharge), parseInt(offerType), Number(offerAmt),
            partilBillAvail,
            paymentDetails,
            setPaymentDetails,
            setLoyalityPointDetails, requiredPayMethodClear);
        setAppliedCoupon(added);
        if (!added) {
            setCoupon("");
        }
    }

    const updateDoTotalByItem = (oldPrice, newPrice, cgst, sgst) => {
        // oldPrice = 0.0,
        //     billTotal = 0.0,
        //     mCgst = 0.0,
        //     mSgst = 0.0,
        //     mPointRedeem = 0.0,
        //     mIgstAllowed = false,
        //     mDelvCharge = 0.0,
        //     m_OfferDenom = OfferType.No_Offer,
        //     m_OfferAmt = 0.0,
        //     partilBillAvail,
        //     paymentDetails,
        //     setPaymentDetails,
        //     setLoyalityPointDetails
        doTotal(oldPrice, newPrice, cgst, sgst,
            loyalityPointDetails,
            paymentDetails.isGstAllowed,
            Number(paymentDetails.delvCharge),
            Number(paymentDetails.takenDenom),
            Number(paymentDetails.takenOffrAmt),
            partilBillAvail,
            paymentDetails,
            setPaymentDetails,
            setLoyalityPointDetails
        );
    };

    const updateByGstDelvCharge = (isGstAllowed, delvCharge) => {
        doTotal(0.0, 0.0, Number(paymentDetails.cgst), Number(paymentDetails.sgst),
            loyalityPointDetails,
            isGstAllowed,
            Number(delvCharge),
            Number(paymentDetails.takenDenom),
            Number(paymentDetails.takenOffrAmt),
            partilBillAvail,
            paymentDetails,
            setPaymentDetails,
            setLoyalityPointDetails
        );
    };

    const updateByOffer = (takenDenom, takenOffrAmt) => {
        doTotal(0.0, 0.0, Number(paymentDetails.cgst), Number(paymentDetails.sgst),
            loyalityPointDetails,
            paymentDetails.isGstAllowed,
            Number(paymentDetails.delvCharge),
            Number(takenDenom),
            Number(takenOffrAmt),
            partilBillAvail,
            paymentDetails,
            setPaymentDetails,
            setLoyalityPointDetails
        );
    }

    //Note: Restaurant item gst are same, so right now its hardcode
    const baseUpdateItems = (cellData, quantity, mPrice, offerDenom, searchedId) => {
        let oldPrice = 0.0;
        let newPrice = 0.0;
        setColumnList((prev) => {
            const index = prev.findIndex((item) => item.prdId === searchedId);
            if (index !== -1) {
                const updatedList = [...prev]; // clone array
                oldPrice = updatedList[index].finalprice;
                newPrice = getFinalPrice(mPrice, cellData.offerAmt, offerDenom, quantity);
                updatedList[index] = {
                    ...updatedList[index],
                    quantity: quantity, print: false, finalprice: newPrice,
                };
                return updatedList;
            } else {
                const item = buildItems(cellData, quantity);
                newPrice = item.finalprice;
                return [...prev, item];
            }
        });
        updateDoTotalByItem(oldPrice, newPrice, Number(cellData.cgst), Number(cellData.sgst));
        fireSnackBarMsg({
            msg: quantity + " X " + cellData.name + " added successfully",
        });
    };

    const updateItems = (cellData, quantity) => {
        if (cellData.price > 0.0) {
            const offerDenom = isNumberEmpty(cellData.offerDenom)
                || cellData.offerDenom === Number.MIN_SAFE_INTEGER
                ? OfferType.No_Offer
                : Number(cellData.offerDenom);
            baseUpdateItems(cellData, quantity, Number(cellData.price), offerDenom, cellData.prdId);
        }
    }

    const handleColQuantityChange = (cellData, event) => {
        printDebugLog("handleColQuantityChange => ", cellData, event.target.value);
        const value = event.target.value;
        let quantity = parseFloat(value);
        if (isNumberEmpty(quantity)) {
            quantity = 0;
        } else {
            quantity = quantity * 1;
            if (!isEmpty(value) && value.length > 1 && value.charAt(0) === '0') {
                event.target.value = quantity;
            }
        }
        quantity = Number(quantity);
        updateItems(cellData, quantity);
    };

    const handleItemNotesUpdate = (cellData) => {
        printDebugLog("handleItemNotesUpdate", cellData);
        setItemDialog(prev => ({
            ...prev,
            dialogMsg: isEmpty(cellData.note) ? "" : cellData.note,
            action: 0, itemName: cellData.name, itemId: cellData.prdId,
        }))
    };

    const localDeleteItemFromBill = (prdId) => {
        setColumnList(prevList => {
            const itemToRemove = prevList.find(item => item.prdId === prdId);
            if (!itemToRemove) return prevList;

            const oldPrice = Number(itemToRemove.price) * itemToRemove.quantity;

            doTotal(oldPrice, 0.0, Number(paymentDetails.cgst), Number(paymentDetails.sgst),
                loyalityPointDetails,
                paymentDetails.isGstAllowed,
                Number(paymentDetails.delvCharge),
                Number(paymentDetails.takenDenom),
                Number(paymentDetails.takenOffrAmt),
                partilBillAvail,
                paymentDetails,
                setPaymentDetails,
                setLoyalityPointDetails
            );

            return prevList.filter(item => item.prdId !== prdId);
        });
    }

    const handleDelClick = (cellData) => {
        printDebugLog("handleDelClick", cellData);
        if (isEmpty(billNo)) {
            localDeleteItemFromBill(cellData.prdId);
        } else {
            if (delReason) {
                setItemDialog(prev => ({
                    ...prev,
                    action: 1, itemName: cellData.name, itemId: cellData.prdId,
                }))
            } else {
                deleteItemFromBill(cellData.prdId, cellData.name, "");
            }
        }
    };

    const fireSnackBarMsg = ({ msg, mHorizontal = "right", mVertical = "top", mColor = "#008b8b" }) => {
        showSnackbar(msg, mColor, mVertical, mHorizontal);
    };

    const isShowDelItemsAvailable = useMemo(() => {
        return isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) && delReason && delItems.length !== 0;
    }, [delReason, delItems]);

    const handleConfig = (mConfigName, configData) => {
        // Mapping config names to their respective state setters
        switch (mConfigName) {
            case BACKDATEALLOWED:
                setBackDateAllowed(configData === 'Yes');
                break;
            case ITEMWISEOFFER:
                setItemWiseOffer(configData === 'Yes');
                break;
            case DELETEBILLCONFIG:
                setDeleteBillOption(configData === 'Yes');
                break;
            case PARTILBILLAUDIT:
                setPartialBillAvail(configData === 'Yes');
                if (!isEmpty(location.state?.sBillNo)) {
                    getBillPartialPay(location.state?.sBillNo);
                }
                break;
            case CUSTLOYALITYPOINT:
                setLoyalityPoints(configData === 'Yes');
                break;
            case HOTELSALESCONFIG:
                setHotelSales(configData === 'Yes');
                break;
            case GENERATEBILL:
                setGenBill(configData === 'Yes');
                break;
            case HOMEDELVDETAILS:
                setHotelDelvTxn(configData === 'Yes');
                break;
            case KOTPRINTITEMWISE:
                setKotPrintItemWise(configData === 'Yes');
                break;
            case KOTPRINTNOWISE:
                setkotPrintNoWise(configData === 'Yes');
                break;
            case DELETEREASON:
                setDelReason(configData === 'Yes');
                break;
            case GSTFEATURE:
                const featureVal = (configData === 'No');
                if (isEmpty(location.state?.sBillNo)) {
                    setPaymentDetails(prev => ({
                        ...prev,
                        isGstAllowed: featureVal,
                    }))
                }
                break;
            case ASKFORPRINT:
                setAskForPrint(configData === 'Yes');
                break;
            case EPAYMENTSMS:
                setEPayInvoice(configData === 'Yes');
                break;
            case CUSTOMER_DISABLE_IN_BILL:
                setCustDisableInBill(configData === 'Yes');
                break;
            default:
                break;
        }
    };


    const getMultipleConfigs = async () => {
        try {
            const listConfigs = [
                GSTFEATURE, HOTELSALESCONFIG, BACKDATEALLOWED,
                ITEMWISEOFFER, DELETEBILLCONFIG, CUSTLOYALITYPOINT, GENERATEBILL,
                HOMEDELVDETAILS, KOTPRINTITEMWISE, KOTPRINTNOWISE, DELETEREASON,
                ASKFORPRINT, EPAYMENTSMS, CUSTOMER_DISABLE_IN_BILL, PARTILBILLAUDIT
            ];
            const fetchConfigUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-multiple-configs`;
            const data = {
                jcJson: {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    shopHash: storeActiveShopHash.id,
                    listConfigs: listConfigs,
                }
            };
            const response = await snpAxios.post(fetchConfigUrl, data);
            printDebugLog("getMultipleConfigs", response.data);
            if (response.data.status === SUCCESS) {
                const mapConfigs = response.data.jcJson.mapConfigs;
                Object.entries(mapConfigs).forEach(([key, value]) => {
                    //printDebugLog("Key:", key, "Value:", value);
                    handleConfig(key, value);
                });
            }
        } catch (error) {
            console.error("getMultipleConfigs", error);
        }
    };

    const getRiderDetails = async () => {
        try {
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-shop-riders?token=${CART_INITIAL_STATE.apiToken}&shopHash=${storeActiveShopHash.id}`;
            const response = await snpAxios.get(cartUrl);
            if (response.data.status === SUCCESS) {
                setRiders(response.data.jcJson.riders);
            }
        } catch (error) {
            console.error("getRiderDetails ", error);
        }
    };

    const getBillItems = async (billNo) => {
        try {
            //setColumnLoader(true);
            const fetchBillUrl = `${storeApiUrl.BACKEND_BASE_URL}billing/get-bill-items?token=${CART_INITIAL_STATE.apiToken}&shopHash=${storeActiveShopHash.id}&billNo=${billNo}`;
            const response = await snpAxios.get(fetchBillUrl);
            printDebugLog("getBillItems", response.data);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setColumnList(isEmpty(payLoad.columnList) ? [] : payLoad.columnList);
                setDelItems(isEmpty(payLoad.delItems) ? [] : payLoad.delItems);
            }
            //setColumnLoader(false);
        } catch (e) {
            console.error("getBillItems", e);
            //setColumnLoader(false);
        }
    };
    const getBillDetails = async (billNo) => {
        try {
            const fetchBillUrl = `${storeApiUrl.BACKEND_BASE_URL}billing/get-bill-details?token=${CART_INITIAL_STATE.apiToken}&shopHash=${storeActiveShopHash.id}&billNo=${billNo}`;
            const response = await snpAxios.get(fetchBillUrl);
            printDebugLog("getBillDetails", response.data);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                if (!isEmpty(payLoad.billAddBy)) {
                    setBillAddBy(payLoad.billAddBy);
                }
                if (!isEmpty(payLoad.tableOwner)) {
                    setTableOwner(payLoad.tableOwner);
                }
                setKot(Number(payLoad.kot));
                setBillNo(payLoad.billNo);
                setBilledFrom(Number(payLoad.billedFrom));
                setGenateOtp(payLoad.generateOtp);
                setCreatedDate(payLoad.createdAt);
                setSettleDown(payLoad.settleDown);
                setCreatedDate(payLoad.createdAt);
                setCustAvailable(payLoad.customerData.custAvailable);
                updateBillStatus(payLoad.billStatus, setBillStatus, setIsPaid);
                setTokenNo(Number(payLoad.tokenNo));
                if (payLoad.customerData.custAvailable) {
                    setCustomerData(prev => ({
                        ...prev, ...payLoad.customerData,
                    }));
                }
                setBillUtils(prev => ({
                    ...prev, ...payLoad.billUtils,
                }));
                setExternalBillDetails(prev => ({
                    ...prev, ...payLoad.externalMap,
                }));
                if (payLoad.tripMap.tripUpdateReq) {
                    getRiderDetails();
                }
                setTripDetails(prev => ({
                    ...prev, ...payLoad.tripMap,
                    pTripStatus: payLoad.tripMap.tripStatus,
                }));
                setReferenceBill(prev => ({
                    ...prev, ...payLoad.referencesMap,
                }));

                if (!isEmpty(payLoad.coupon)) {
                    setCoupon(payLoad.coupon);
                    setAppliedCoupon(true);
                }

            }
        } catch (e) {
            console.error("getBillDetails", e);
        }
    };

    const getBillPayDetails = async (billNo) => {
        try {
            setPaymentLoader(true);
            const fetchBillUrl = `${storeApiUrl.BACKEND_BASE_URL}billing/get-bill-pay-details?token=${CART_INITIAL_STATE.apiToken}&shopHash=${storeActiveShopHash.id}&billNo=${billNo}`;
            const response = await snpAxios.get(fetchBillUrl);
            printDebugLog("getBillPayDetails", response.data);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setPaymentDetails(prev => ({
                    ...prev, ...payLoad
                }));
            }
            setPaymentLoader(false);
        } catch (e) {
            console.error("getBillPayDetails", e);
            setPaymentLoader(false);
        }
    };

    const getBillPartialPay = async (billNo) => {
        try {
            const fetchBillUrl = `${storeApiUrl.BACKEND_BASE_URL}billing/get-bill-partial-pay?token=${CART_INITIAL_STATE.apiToken}&shopHash=${storeActiveShopHash.id}&billNo=${billNo}`;
            const response = await snpAxios.get(fetchBillUrl);
            printDebugLog("getBillPartialPay", response.data);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setTakenPartialPay(payLoad.takenPartialPay);
                setDuesAmt(Number(payLoad.duesAmt) || 0.0);
                setPartialPayList(isEmpty(payLoad.lpatialAmt) ? [] : payLoad.lpatialAmt);
            }
            setSnpLoader(false);
        } catch (e) {
            console.error("getBillPartialPay", e);
            setSnpLoader(false);
        }
    };

    const fetchBill = (billNo) => {
        printDebugLog("fetchBill", billNo);
        getBillItems(billNo);
        getBillDetails(billNo);
        getBillPayDetails(billNo);
    };


    const kotprint = async (isKot) => {
        try {
            if (columnList === 0) {
                fireSnackBarMsg({ msg: "Please Add Item to Start billing" });
                return;
            } else if (!isEmpty(externalBillDetails.hotelBillId) && !custDisableInBill && isEmpty(customerData.custMob)) {
                fireSnackBarMsg({ msg: "Please Add Customer Details" });
                return;
            }
            setSnpLoader(true);
            //TODO use isMobile from Aman
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            const settleUrl = storeApiUrl.BACKEND_BASE_URL + (isKot ? RESTO_KOT : INITIATESAVEBILL);
            const bStatus = (billStatus === BillStatus.NO_ENTRY) ? BillStatus.INITIATED : billStatus;
            const jcJson = kotJsonData(columnList,
                storeActiveShopHash.id, billNo, billUtils.tableId, isMobile, billUtils.billType, isOthHomeDelv, delvNameOth,
                createdDate, bStatus, kotCopies,
                paymentDetails, customerData, externalBillDetails, tripDetails, coupon, appliedCoupon);
            const settleData = { jcJson };
            printDebugLog("kotprint", settleData);
            const response = await snpAxios.post(settleUrl, settleData);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setBillNo(payLoad.billNo);
                setBillStatus(Number(payLoad.billStatus));
                setTokenNo(Number(payLoad.token));
                setKot(Number(payLoad.kot));
                setDuesAmt(Number(paymentDetails.finalPrice));
                setCustomerData(prev => ({
                    ...prev,
                    custId: payLoad.custId,
                }));
                baseRaiseInvoiceClicked(storeApiUrl.BACKEND_BASE_URL,
                    CART_INITIAL_STATE.apiToken, storeActiveShopHash.id,
                    payLoad.print,
                    "kot", isMobile, payLoad.billNo, (msg) => fireSnackBarMsg({ msg: msg }));
            }
            setSnpLoader(false);
        } catch (error) {
            console.error(`kotprint(${isKot})`, error);
            setSnpLoader(false);
        }
    };

    const handleUpdateTripStatus = async () => {
        try {
            setSnpLoader(true);
            const settleUrl = `${storeApiUrl.BACKEND_BASE_URL}cart/update-bill-order-web`;
            const settleData = {
                jcJson: {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    shopHash: storeActiveShopHash.id,
                    billNo: billNo,
                    kitchenStatus: isEmpty(tripDetails.tripStatus) ? SEND_TO_KITCHEN : tripDetails.tripStatus,
                }
            }
            const response = await snpAxios.post(settleUrl, settleData);
            if (response.data.status === SUCCESS) {
                fireSnackBarMsg({ msg: `Status updated to ${tripDetails.tripStatus}` });
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("handleUpdateTripStatus", error);
            setSnpLoader(false);
        }
    };

    const handlePayLater = async () => {
        try {
            if (isEmpty(customerData.custMob) && !custDisableInBill) {
                fireSnackBarMsg({ msg: "Please Add Customer Details" });
                return;
            }
            setSnpLoader(true);
            //TODO use isMobile from Aman
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            const custSaveUrl = `${storeApiUrl.BACKEND_BASE_URL}${PAYLATERRESTOBILL}`;
            const jcJson = payLaterJsonData(columnList,
                storeActiveShopHash.id, billNo, billUtils.tableId, isMobile, billUtils.billType, isOthHomeDelv, delvNameOth,
                createdDate, BillStatus.NOTPAID, settleDown, loyalityPointDetails,
                paymentDetails, customerData, externalBillDetails);
            const saveBillData = { jcJson };
            delete saveBillData.jcJson.royalityPoint;
            const response = await snpAxios.post(custSaveUrl, saveBillData);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setBillNo(payLoad.billNo);
                setBillStatus(Number(payLoad.billStatus));
                setTokenNo(Number(payLoad.token));
                setCustomerData(prev => ({
                    ...prev,
                    custId: payLoad.custId,
                }));
                setPrintDetails(prev => ({
                    ...prev,
                    custPrint: payLoad.custprint
                }));
                setCustCopy(true);
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("handlePayLater", error);
            setSnpLoader(false);
        }
    };

    const initiatePayment = async (isPartial) => {
        try {
            if (!isPartial && (isEmpty(paymentDetails.onlinePayThrough) && isEmpty(paymentDetails.cashPayThrough))) {
                fireSnackBarMsg({ msg: "Please Select any of the Payment method" });
                return;
            } else if (!isPartial && (paymentDetails.payMedium === PayMedium.ONLINE || paymentDetails.payMedium === PayMedium.BOTH)
                && isEmpty(paymentDetails.onlinePayMedium)) {
                fireSnackBarMsg({ msg: "Please Select Online Pay Method" });
                return;
            } else if (billUtils.billType !== InternalBillType.Home && isEmpty(customerData.custMob) && !custDisableInBill) {
                fireSnackBarMsg({ msg: "Please Add Customer Details" });
                return;
            } else if (billUtils.billType === InternalBillType.Home && isEmpty(paymentDetails.delvName)) {
                fireSnackBarMsg({ msg: "Please Select Home Delivery" });
                return;
            } else if (billUtils.billType === InternalBillType.Home && isOthHomeDelv && isEmpty(delvNameOth)) {
                fireSnackBarMsg({ msg: "Please Enter other Home Delivery" });
                return;
            }
            setSnpLoader(true);
            //TODO use isMobile from Aman
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            const custSaveUrl = `${storeApiUrl.BACKEND_BASE_URL}${POSTRESTOBILL}`;

            if (isPartial) {
                if (Number(partialPay.partialAmt) === Number(paymentDetails.finalPrice)) {
                    isPartial = false;
                }
            }

            const jcJson = initiatePayJsonData(columnList,
                storeActiveShopHash.id, billNo, billUtils.tableId, isMobile, billUtils.billType, isOthHomeDelv, delvNameOth,
                createdDate, isPartial, loyalityPointDetails,
                paymentDetails, customerData, externalBillDetails, partialPay, coupon, appliedCoupon);
            const saveBillData = { jcJson };
            delete saveBillData.jcJson.royalityPoint;
            const response = await snpAxios.post(custSaveUrl, saveBillData);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setBillNo(payLoad.billNo);
                setTokenNo(Number(payLoad.token));
                updateBillStatus(payLoad.billStatus, setBillStatus, setIsPaid);
                setCustomerData(prev => ({
                    ...prev,
                    custId: payLoad.custId,
                }));
                setGenateOtp(payLoad.generateOtp);
                setDuesAmt(Number(payLoad.duesAmt));
                if (askForPrint) {
                    setPrintDetails(prev => ({
                        ...prev,
                        custPrint: payLoad.custprint,
                        shopPrint: payLoad.shopPrint,
                    }));
                    setCustCopy(true);
                } else {
                    baseRaiseInvoiceClicked(storeApiUrl.BACKEND_BASE_URL,
                        CART_INITIAL_STATE.apiToken, storeActiveShopHash.id,
                        payLoad.custprint,
                        "cust", isMobile, payLoad.billNo, (msg) => fireSnackBarMsg({ msg: msg }));
                }
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("initiatePayment", error);
            setSnpLoader(false);
        }
    };

    const generateBill = async () => {
        try {
            if (!isEmpty(generateOtp) && genBill) {
                if (isEmpty(itemDialog.dialogMsg) || itemDialog.dialogMsg !== generateOtp) {
                    setItemDialog(INITIAL_ITEM_DIALOG);
                    fireSnackBarMsg({ msg: "Entered OTP is wrong" });
                    return;
                }
            }
            setItemDialog(INITIAL_ITEM_DIALOG);
            setSnpLoader(true);
            //TODO use isMobile from Aman
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            const custSaveUrl = `${storeApiUrl.BACKEND_BASE_URL}${POSTRESTOBILL}`;
            const jcJson = generateInititalPayLinkBillJsonData(columnList,
                storeActiveShopHash.id, billNo, billUtils.tableId, isMobile, billUtils.billType, isOthHomeDelv, delvNameOth,
                createdDate, loyalityPointDetails,
                paymentDetails, customerData, externalBillDetails, partialPay, coupon, appliedCoupon);
            const saveBillData = { jcJson };
            delete saveBillData.jcJson.royalityPoint;
            const response = await snpAxios.post(custSaveUrl, saveBillData);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setBillNo(payLoad.billNo);
                setBillStatus(Number(payLoad.billStatus));
                setTokenNo(Number(payLoad.token));
                setCustomerData(prev => ({
                    ...prev,
                    custId: payLoad.custId,
                }));
                setGenateOtp(payLoad.generateOtp);

                baseRaiseInvoiceClicked(storeApiUrl.BACKEND_BASE_URL,
                    CART_INITIAL_STATE.apiToken, storeActiveShopHash.id,
                    payLoad.custprint,
                    "gen", isMobile, payLoad.billNo, (msg) => fireSnackBarMsg({ msg: msg }));
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("generateBill", error);
            setSnpLoader(false);
        }
    };

    /**
     * 
     * @param {int} printFor = 1 means shop , 0 means cust
     */
    const printBillAfterPay = async (printFor) => {
        try {
            setSnpLoader(true);
            //TODO use isMobile from Aman
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            const masterUrl = isMobile ? PRINT_RESTO_BILL_MOBILE : PRINT_RESTO_BILL;
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${masterUrl}/${CART_INITIAL_STATE.apiToken}/${billNo}/${storeActiveShopHash.id}/${printFor}`;
            const response = await axios.get(cartUrl);
            if (response.data !== '') {
                baseRaiseInvoiceClicked(storeApiUrl.BACKEND_BASE_URL,
                    CART_INITIAL_STATE.apiToken, storeActiveShopHash.id,
                    response.data,
                    printFor === 1 ? "shop" : "cust", isMobile, billNo, (msg) => fireSnackBarMsg({ msg: msg }));
            }
            setSnpLoader(false);
        } catch (error) {
            console.error(`printBillAfterPay${printFor}`, error);
            setSnpLoader(false);
        }
    };

    const finalSettle = async () => {
        try {
            if (billStatus === BillStatus.INITIATED) {
                showSnpDialogForShowStatus("First Initiate Pay to Settle the bill");
                return;
            }

            const custSaveUrl = `${storeApiUrl.BACKEND_BASE_URL}${SETTLE_RESTO_BILL}`;
            setSnpLoader(true);
            const jcJson = {
                value: CART_INITIAL_STATE.apiToken,
                shopHash: storeActiveShopHash.id,
                billNo: billNo,
                settleDown: true,
                ...buildJsonExternalData(externalBillDetails),
            };
            const saveBillData = { jcJson };
            delete saveBillData.jcJson.royalityPoint;
            const response = await snpAxios.post(custSaveUrl, saveBillData);
            if (response.data.status === SUCCESS) {
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    negativeAction: "Ok!", subTitle: "Bill Successfully Settled",
                    handleClose: () => {
                        closeDialog();
                        navigate("/dashboard");
                    },
                });
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("finalSettle", error);
            setSnpLoader(false);
        }
    };

    const deleteEntireBill = async () => {
        try {
            setSnpLoader(true);
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${DELETEBILL}/${CART_INITIAL_STATE.apiToken}/${billNo}/${storeActiveShopHash.id}`;
            const response = await axios.get(cartUrl);
            setSnpLoader(false);
            if (response.data === SUCCESS) {
                navigate("/dashboard");
            } else if (response.data === ROLEERROR) {
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    negativeAction: "Ok!", subTitle: "You're not allowed to Delete Bill! Contact Shop Admin",
                    handleClose: () => {
                        closeDialog();
                    },
                });
            }

        } catch (error) {
            console.error("deleteEntireBill", error);
            setSnpLoader(false);
        }
    };

    const handleInitiatePayLink = async () => {
        try {
            if (isEmpty(customerData.custMob) && !custDisableInBill) {
                fireSnackBarMsg({ msg: "Please Add Customer Details" });
                return;
            }
            setSnpLoader(true);
            //TODO use isMobile from Aman
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            const custSaveUrl = `${storeApiUrl.BACKEND_BASE_URL}${INITIATEPAYLINK}`;
            const jcJson = generateInititalPayLinkBillJsonData(columnList,
                storeActiveShopHash.id, billNo, billUtils.tableId, isMobile, billUtils.billType, isOthHomeDelv, delvNameOth,
                createdDate, loyalityPointDetails,
                paymentDetails, customerData, externalBillDetails, partialPay, coupon, appliedCoupon, "apiToken");
            const saveBillData = { jcJson };
            delete saveBillData.jcJson.royalityPoint;
            const response = await snpAxios.post(custSaveUrl, saveBillData);
            if (response.data.status === SUCCESS) {
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    negativeAction: "Ok!", subTitle: "Success Initiated",
                    handleClose: () => {
                        closeDialog();
                    },
                });
            } else if (response.data.status === ROLEERROR) {
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    negativeAction: "Ok!", subTitle: "You're not allowed to Delete Bill! Contact Shop Admin",
                    handleClose: () => {
                        closeDialog();
                    },
                });
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("generateBill", error);
            setSnpLoader(false);
        }
    };

    const kotDisplay = async (prdId) => {
        try {
            setSnpLoader(true);
            const dUrl = `${storeApiUrl.BACKEND_BASE_URL}${GETKOTBYITEM}/${CART_INITIAL_STATE.apiToken}/${billNo}/${storeActiveShopHash.id}/${prdId}`;
            const response = await snpAxios.get(dUrl);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    negativeAction: "Dismiss",
                    positiveReq: kotPrintItemWise,
                    positiveAction: "Print",
                    iconContent: <SoupKitchenIcon />,
                    gui: <BuildKotDisplayData
                        prodName={payLoad.prdName}
                        kots={payLoad.kots} />,
                    handleClose: () => {
                        closeDialog();
                    },
                    handleSubmit: () => {
                        printKotItmeWise(prdId);
                        closeDialog();
                    }
                });
            } else {
                showSnpDialogForShowStatus("Still Bill not reached to KOT state!");
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("kotDisplay", error);
            setSnpLoader(false);
            showSnpDialogForShowStatus("Still Bill not reached to KOT state!");
        }
    };

    const printKotItmeWise = async (prdId) => {
        try {
            setSnpLoader(true);
            const dUrl = `${storeApiUrl.BACKEND_BASE_URL}${PRINT_RESTO_KOT_ITEM}/${CART_INITIAL_STATE.apiToken}/${billNo}/${storeActiveShopHash.id}/${prdId}`;
            const response = await axios.get(dUrl);
            if (response.data !== '') {
                const isMobile = window.matchMedia('(max-width: 767px)').matches;
                baseRaiseInvoiceClicked(storeApiUrl.BACKEND_BASE_URL,
                    CART_INITIAL_STATE.apiToken, storeActiveShopHash.id,
                    response.data,
                    "def", isMobile, billNo, (msg) => fireSnackBarMsg({ msg: msg }));
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("printKotItmeWise", error);
            setSnpLoader(false);
        }
    };

    const printKotNoWise = async () => {
        try {
            if (isNumberEmpty(itemDialog.dialogMsg)) {
                fireSnackBarMsg({ msg: "Please enter Kot number", mColor: "#d60026" });
                return;
            } else if (Number(itemDialog.dialogMsg) === 0) {
                fireSnackBarMsg({ msg: "Please enter valid kot number(i.e. 1 to ....)", mColor: "#d60026" });
                return;
            }
            setSnpLoader(true);
            const dUrl = `${storeApiUrl.BACKEND_BASE_URL}${PRINT_RESTO_KOT_NO}/${CART_INITIAL_STATE.apiToken}/${billNo}/${storeActiveShopHash.id}/${itemDialog.dialogMsg}`;
            const response = await axios.get(dUrl);
            if (response.data !== '' && !response.data.includes("Error@")) {
                const isMobile = window.matchMedia('(max-width: 767px)').matches;
                baseRaiseInvoiceClicked(storeApiUrl.BACKEND_BASE_URL,
                    CART_INITIAL_STATE.apiToken, storeActiveShopHash.id,
                    response.data,
                    "def", isMobile, billNo, (msg) => fireSnackBarMsg({ msg: msg }));
            } else if (response.data !== '' && response.data.includes("Error@")) {
                fireSnackBarMsg({ msg: response.data, mColor: "#d60026" });
            }
            setItemDialog(INITIAL_ITEM_DIALOG);
            setSnpLoader(false);
        } catch (error) {
            console.error(`printKotNoWise ${itemDialog.dialogMsg}`, error);
            setSnpLoader(false);
            setItemDialog(INITIAL_ITEM_DIALOG);
        }
    }

    const deleteItemFromBill = async (prdId, itemName, deltedMessage) => {
        try {
            if (delReason && isEmpty(deltedMessage)) {
                fireSnackBarMsg({ msg: "Enter Reason for delete" });
                return;
            }
            setSnpLoader(true);
            const dUrl = `${storeApiUrl.BACKEND_BASE_URL}${DEL_ITEM_BILL}`;
            const data = {
                jcJson: {
                    value: CART_INITIAL_STATE.apiToken,
                    value_1: prdId,
                    shopHash: storeActiveShopHash.id,
                    value_2: billNo,
                    delMsg: deltedMessage,
                }
            };
            setItemDialog(INITIAL_ITEM_DIALOG);
            const response = await snpAxios.post(dUrl, data);
            if (response.data.status === SUCCESS || response.data.status === NOITEMSAVAILABLE) {
                localDeleteItemFromBill(prdId);
                fireSnackBarMsg({ msg: itemName + " deleted successfully" });
            }
            setSnpLoader(false);

        } catch (error) {
            console.error("deleteItemFromBill", error);
            setSnpLoader(false);
        }
    };

    const removeRoomApi = async () => {
        try {
            if (isEmpty(externalBillDetails.hotelBillNo)) {
                fireSnackBarMsg({ msg: "Plase Enter Room Details before delete" });
                return;
            }
            setSnpLoader(true);
            const mUrl = `${storeApiUrl.BACKEND_BASE_URL}${DELROOM}`;
            const data = {
                jcJson: {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    hotelBillId: externalBillDetails.hotelBillId,
                    billNo: billNo,
                    shopHash: storeActiveShopHash.id,
                }
            };
            const response = await snpAxios.post(mUrl, data);
            if (response.data.status === SUCCESS) {
                fetchBill(billNo);
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("removeRoomApi", error);
            setSnpLoader(false);
        }
    };

    const updatePartialPayMoney = async () => {
        try {
            if (billStatus === BillStatus.INITIATED) {
                setPartialPayDialog(false);
                initiatePayment(true);
            } else {
                if (billUtils.billType !== InternalBillType.Home && !custDisableInBill && isEmpty(customerData.custMob)) {
                    fireSnackBarMsg({ msg: "Please Add Customer Details" });
                    return;
                } else if (isEmpty(partialPay.onlineBillPaidThrough) && isEmpty(partialPay.cashBillPaidThrough)) {
                    fireSnackBarMsg({ msg: "Please Select any of the Payment method" });
                    return;
                } else if ((!isEmpty(partialPay.cashBillPaidThrough)) && isNumberEmpty(parseFloat(partialPay.cashTendered))) {
                    fireSnackBarMsg({ msg: "Please Input the Cash Tender Amount" });
                    return;
                } else if (isNumberEmpty(Number(partialPay.partialAmt))) {
                    fireSnackBarMsg({ msg: "Please Add Partial Amount" });
                    return;
                }
                setSnpLoader(true);
                const custSaveUrl = `${storeApiUrl.BACKEND_BASE_URL}${UPDATEPARTIALPAY}`;
                const jcJson = {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    shopHash: storeActiveShopHash.id,
                    partialBillAudit: partialPay,
                    billNo: billNo,
                    ...buildJconCustData(customerData),
                };

                const saveBillData = { jcJson };
                const response = await snpAxios.post(custSaveUrl, saveBillData);
                if (response.data.status === SUCCESS) {
                    const payLoad = response.data.jcJson;
                    setPrintDetails(prev => ({
                        ...prev,
                        custPrint: payLoad.custprint,
                    }));
                    setDuesAmt(Number(payLoad.duesAmt));
                    if (!payLoad.custprint.includes('Successfully Print')) {
                        setCustCopy(true);
                    } else {
                        const isMobile = window.matchMedia('(max-width: 767px)').matches;
                        baseRaiseInvoiceClicked(storeApiUrl.BACKEND_BASE_URL,
                            CART_INITIAL_STATE.apiToken, storeActiveShopHash.id,
                            payLoad.custprint,
                            "cust", isMobile, billNo, (msg) => fireSnackBarMsg({ msg: msg }));
                    }
                    getBillPartialPay(billNo);
                    getBillPayDetails(billNo);
                } else {
                    setSnpLoader(false);
                }
                setPartialPay(INITIAL_PARTIAL_PAY);
                setPartialPayDialog(false);
            }
        } catch (error) {
            console.error("updatePartialPayMoney", error);
            setSnpLoader(false);
        }
    };

    const getGlobalVoucherCheck = async () => {
        try {
            setSnpLoader(true);
            let m_payType = "";
            if (paymentDetails.payMedium === PayMedium.ONLINE) {
                m_payType = paymentDetails.onlinePayMedium;
            } else if (paymentDetails.payMedium === PayMedium.CASH) {
                m_payType = CASHPAY;
            } else if (paymentDetails.payMedium === PayMedium.BOTH) {
                m_payType = CASHPAY + "-" + paymentDetails.onlinePayMedium;
            }
            const params = {
                shopHash: storeActiveShopHash.id,
                voucherCode: coupon,
                amt: paymentDetails.totalPrice,
                mob: customerData.custMob,
                email: customerData.custEmail,
                billType: billUtils.billType,
                payType: m_payType,
                deliveryType: paymentDetails.delvName,
            };

            const query = Object.entries(params)
                .filter(([_, v]) => v !== undefined && v !== null && v !== "")
                .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
                .join("&");
            printDebugLog("getGlobalVoucherCheck:query", query);
            const dUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}a2z-global-voucher-check?${query}`;
            const response = await axios.get(dUrl);
            printDebugLog("getGlobalVoucherCheck", response.data);
            if (response.data.status === SUCCESS) {
                updateBasedOnCoupon(true, response.data.jcJson.offerType, response.data.jcJson.offerAmt, false);
            } else {
                const errorMessage = response.data.errorMessage;
                fireSnackBarMsg({ msg: errorMessage, mColor: "#d60026" });
            }
            setSnpLoader(false);
        } catch (err) {
            setSnpLoader(false);
            console.error("getGlobalVoucherCheck", err);
            fireSnackBarMsg({ msg: "Network Error Try again", mColor: "#d60026" });
        }
    };


    const columns = [
        {
            field: 'prddets', headerName: 'Item',
            width: 230, valueGetter: (params) => params.row, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "16px" }}>{params.row.name + (!isEmpty(params.row.foodQuantityName) ? "(" + params.row.foodQuantityName + ")" : '')}</p>
            ),
        },
        {
            field: 'quantity', headerName: 'Qty', minWidth: 180, width: 210, editable: true,
            renderCell: (val) => {
                return (
                    <Grid container spacing={0}>
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                            <TextField
                                id="colQuantity"
                                className={colQuantityClasses.input}
                                name="colQuantity"
                                type="number"
                                inputMode="numeric"
                                value={Number(val.row.quantity)}
                                variant="standard"
                                size="small"
                                sx={{
                                    justifyContent: "center", alignContent: "center",
                                    '& .UiInputBase-input': {
                                        textAlign: "center",
                                    },
                                }}
                                onChange={(e) => handleColQuantityChange(val.row, e)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <IconButton onClick={() => handleIncrement(val.row, updateItems)}>
                                                <AddIcon color="success" sx={{
                                                    fontSize: "2rem",
                                                }} />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => handleDecrement(val.row, updateItems)}>
                                                <RemoveIcon color="warning" sx={{
                                                    fontSize: "2rem",
                                                }} />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                    </Grid>
                );
            },
        },
        {
            field: 'savedQuantity', headerName: 'P.Qty', width: 70
        },
        {
            field: 'finalPrice', headerName: 'T. Price', width: 100,
            renderCell: (val) => {
                return "\u20B9 " + val.row.finalprice;
            }
        },
        {
            field: "select",
            headerName: "Notes",
            width: 90,
            renderCell: (cellValues) => {
                return (
                    <CommentIcon disableRipple sx={{
                        WebkitTapHighlightColor: 'transparent',
                        transition: 'background-color 0.2s ease',
                        cursor: "pointer"
                    }}
                        onPointerDown={() => handleItemNotesUpdate(cellValues.row)}>
                    </CommentIcon>
                );
            }
        },
        {
            field: "del",
            headerName: "",
            renderCell: (cellValues) => {
                return (
                    <>
                        {
                            !isPaid &&
                            <SnpButton variant="contained"
                                mbgcolor="#ca241e"
                                mpadding="1px"
                                disableRipple
                                sx={{
                                    WebkitTapHighlightColor: 'transparent',
                                    transition: 'background-color 0.2s ease',
                                    cursor: "pointer"
                                }}
                                onPointerDown={() => handleDelClick(cellValues.row)}
                            >Del</SnpButton>
                        }
                    </>
                );
            }
        },
        {
            field: "kot",
            headerName: "KOT",
            renderCell: (cellValues) => {
                return (
                    <SoupKitchenIcon style={{ cursor: "pointer" }}
                        onPointerDown={() => {
                            kotDisplay(cellValues.row.prdId);
                        }}
                    >
                    </SoupKitchenIcon>
                );
            }
        }
    ];

    const memorizedBillPayScreen = useMemo(() => {
        return (
            <RestoBillPayScreen
                billType={Number(billUtils.billType)}
                paymentDetails={paymentDetails}
                payLoader={payLoader}
                isPaid={isPaid}
                delvNameOth={delvNameOth}
                setDelvNameOth={setDelvNameOth}
                setOtherHomeDelv={setOtherHomeDelv}
                isOthHomeDelv={isOthHomeDelv}
                setPaymentDetails={setPaymentDetails}
                hotelDelvTxn={hotelDelvTxn}
                externalBillDetails={externalBillDetails}
                setExternalBillDetails={setExternalBillDetails}
                loyalityPointDetails={loyalityPointDetails}
                updateByGstDelvCharge={updateByGstDelvCharge}
                updateByOffer={updateByOffer}
                fireSnackBarMsg={fireSnackBarMsg}
                settleDown={settleDown}
                billedFrom={billedFrom}
                tripDetails={tripDetails}
                setTripDetails={setTripDetails}
                riders={riders}
                billStatus={billStatus}
                showSnpDialogForUpdateStatus={showSnpDialogForShowStatus}
                coupon={coupon}
                appliedCoupon={appliedCoupon}
                setCoupon={(val) => setCoupon(val)}
                handleApply={() => {
                    if (!isEmpty(coupon)) {
                        getGlobalVoucherCheck();
                    } else {
                        fireSnackBarMsg({ msg: "Please enter coupon first" })
                    }
                }}
                handleRemove={() => {
                    updateBasedOnCoupon(false, OfferType.No_Offer, 0.0, false)
                }}
            />
        )
    }, [billUtils.billType, paymentDetails, payLoader, isPaid, delvNameOth, isOthHomeDelv,
        hotelDelvTxn, externalBillDetails, loyalityPointDetails, settleDown, billedFrom, tripDetails, riders, billStatus, coupon, appliedCoupon]);

    return (
        <Grid container spacing={1}>
            <RenderBillHeader
                billNo={billNo}
                selectedDate={createdDate}
                mbackgroundcolor='#ffd7d7'
                handleClearEveryThing={handleClearUi}
                billUtils={billUtils}
                isPaid={isPaid}
                token={tokenNo}
                refreshBill={() => fetchBill(billNo)}
                backDateAllowed={backDateAllowed}
                setDateChange={setDateChange}
            />

            <RenderItemSearch
                baseUrl={storeApiUrl.BACKEND_BASE_URL}
                encodedHash={utilities.encode(storeActiveShopHash.id)}
                shopHashId={storeActiveShopHash.id}
                handleUpdateColumn={handleUpdateColumn}
                columnList={columnList}
                isPaid={isPaid}
                fireSnackBarMsg={fireSnackBarMsg}
            />
            {
                isShowDelItemsAvailable &&
                <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
                    <div>
                        <SnpButton variant="contained"
                            color="primary"
                            style={{
                                float: "right", whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word'
                            }}
                            onPointerDown={() => showDialog({
                                ...dialogConfig,
                                negativeReq: true,
                                negativeAction: "Dismiss",
                                gui: <BuildDelItemDisplayData
                                    delItems={delItems} />,
                                handleClose: () => {
                                    closeDialog();
                                },
                            })}>
                            Show Deleted Items
                        </SnpButton></div></Grid>
            }
            <Grid item xs={12}>
                <CustomDataGrid
                    getRowId={row => row.prdId}
                    rows={columnList}
                    columns={columns}
                />
            </Grid>
            {
                (!isPaid || (isPaid && (isEmpty(externalBillDetails.hotelBillId) && isEmpty(customerData.custId))))
                && <Grid item xs={12}>
                    <RenderCustomerHotelForm
                        isPaid={isPaid}
                        customerData={customerData}
                        custAvailable={custAvailable}
                        storeApiUrl={storeApiUrl}
                        storeActiveShopHash={storeActiveShopHash}
                        setCustAvailable={setCustAvailable}
                        setCustomerData={setCustomerData}
                        setCustDialog={setCustDialog}
                        setLoyalityPointDetails={setLoyalityPointDetails}
                        hotelSale={hotelSale}
                        billType={billUtils.billType}
                        externalBillDetails={externalBillDetails}
                        setHotelRoomDialog={setHotelRoomDialog}
                    />
                </Grid>
            }

            {memorizedBillPayScreen}
            {
                billStatus < BillStatus.PARTIALLYPAID && CART_INITIAL_STATE.kotCopiesAllowed
                &&
                <Grid item xs={12}>
                    <TextField
                        id="dkotCopies"
                        className={colQuantityClasses.input}
                        name="dkotCopies"
                        type="number"
                        inputMode="numeric"
                        disabled
                        value={kotCopies || 1}
                        variant="outlined"
                        helperText={"KOT Copies"}
                        size="small"
                        sx={{
                            justifyContent: "center", alignContent: "center",
                            '& .UiInputBase-input': {
                                textAlign: "center",
                            },
                            width: {
                                xs: '60%',    // 0-600px
                                sm: '30%',   // 600-900px
                                md: '20%',   // 900-1200px
                                lg: '20%'    // 1200px+
                            },
                            padding: {
                                xs: "5px",
                                sm: "5px",
                                md: "5px",
                                lg: "5px"
                            }
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <IconButton onPointerDown={() => setKopies((prev) => prev + 1)}>
                                        <AddIcon color="success" sx={{
                                            fontSize: "2rem",
                                        }} />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="start">
                                    <IconButton onPointerDown={() => setKopies((prev) => Math.max(1, prev - 1))}>
                                        <RemoveIcon color="warning" sx={{
                                            fontSize: "2rem",
                                        }} />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>
            }
            <Grid item xs={12}>
                <RestoButton
                    paymentDetails={paymentDetails}
                    isOthHomeDelv={isOthHomeDelv}
                    delvNameOth={delvNameOth}
                    tripDetails={tripDetails}
                    externalBillDetails={externalBillDetails}
                    generateOtp={generateOtp}
                    customerData={customerData}
                    billedFrom={Number(billedFrom)}
                    billStatus={Number(billStatus)}
                    kot={kot}
                    snpLoader={snpLoader}
                    isPaid={isPaid}
                    columnList={columnList}
                    kotPrintNoWise={kotPrintNoWise}
                    partilBillAvail={partilBillAvail}
                    duesAmt={duesAmt}
                    billUtils={billUtils}
                    deletBillOption={deletBillOption}
                    ePayInvoice={ePayInvoice}
                    settleDown={settleDown}
                    kotprint={kotprint}
                    setPrintKotNoDialog={setPrintKotNoDialog}
                    handleUpdateTripStatus={handleUpdateTripStatus}
                    handlePartialPayChange={() => setPartialPayDialog(true)}
                    handlePayLater={handlePayLater}
                    initiatePayment={initiatePayment}
                    handleGenBill={handleGenBill}
                    printBillAfterPay={printBillAfterPay}
                    finalSettle={finalSettle}
                    deleteEntireBill={deleteEntireBill}
                    handleInitiatePayLink={handleInitiatePayLink}
                />
            </Grid>
            <RestoDialogBase
                custDialog={custDialog}
                setCustDialog={setCustDialog}
                customerData={customerData}
                setCustomerData={setCustomerData}
                custCopy={custCopy}
                setCustCopy={setCustCopy}
                printCustomerBill={printCustomerBill}
                itemDialog={itemDialog}
                setItemDialog={setItemDialog}
                callItemOperation={callItemOperation}
                createdAt={createdDate}
                setCreatedAt={setCreatedDate}
                dateChange={dateChange}
                setDateChange={setDateChange}
                backDateAllowed={backDateAllowed}
                hotelRoomDialog={hotelRoomDialog}
                setHotelRoomDialog={setHotelRoomDialog}
                externalBillDetails={externalBillDetails}
                setExternalBillDetails={setExternalBillDetails}
                fireSnackBarMsg={fireSnackBarMsg}
                setCustAvailable={setCustAvailable}
                billStatus={billStatus}
                takenPartialPay={takenPartialPay}
                removeRoomApi={removeRoomApi}
                kot={kot}
                partialPayDialog={partialPayDialog}
                setPartialPayDialog={setPartialPayDialog}
                partialPay={partialPay}
                duesAmt={duesAmt}
                currDues={currDues}
                partialPayList={partialPayList}
                setPartialPay={setPartialPay}
                setCurrDues={setCurrDues}
                updatePartialPayMoney={updatePartialPayMoney}
            />
        </Grid>
    );
};

export default RestoKeyboardQuickBill;